<template>
  <div
    :class="{
      'd-flex justify-center': $isCreditOnline()
    }"
  >
    <NewRegisterForm v-if="$isCreditOnline()" :hideToolbarDialogProp="true" />
    <RegisterForm v-else :hideCloseDialogProp="true" />
  </div>
</template>
<script>
import RegisterForm from "@/views/home/register";
import NewRegisterForm from "@/views/home/register/newRegisterForm";
import getInfoTable from "@/util/infoTable.js";

export default {
  name: "RegisterPlayerView",
  components: {
    RegisterForm,
    NewRegisterForm,
  },
  created() {
    if (this.$route.name === "Register") {
      if (this.$store.state.operators.credit === undefined) {
        getInfoTable();
      }
    }
  },
  watch: {
    $route(val) {
      if (val.name === "Register") {
        if (this.$store.state.operators.credit === undefined) {
          getInfoTable();
        }
      }
    }
  }
};
</script>
